import en from './locales/en.json';
import de from './locales/de.json';

export const cardsLocales = {
  en: { cards: en },
  de: { cards: de },
};

export { cardsRoutes } from './cards.routes';
export { default as CardTransactionDetails } from './components/drawers/CardTransactionDetails.vue';
export { useCardTransactionRows } from './composables/useCardTransactionRows';
export {
  CARDS_ROUTE_NAME,
  CARD_DETAILS_ROUTE_NAME,
  ORDER_CARD_ROUTE_NAME,
} from './internal/cards.constants';
